import { Heart, Globe, Radio, ListChecks, Share2, Gamepad2, Image as ImageIcon, Wand2, Wallet, Users, LayoutGrid, FileSignature, Store, Palette, QrCode, Building2, CalendarCheck, Sparkles } from "lucide-react";

const U = (id, w = 1400) => `https://images.unsplash.com/${id}?auto=format&fit=crop&q=85&w=${w}`;

export const AUDIENCES = {
  couples: {
    key: "couples",
    tab: "Couples",
    path: "/for-couples",
    eyebrow: "For couples",
    title: "Every milestone.",
    accent: "Organized forever.",
    blurb: "Your virtual wedding planning tool: every checklist, payment, guest and milestone in one place. It works hand in hand with your planner, never instead of them.",
    image: "https://images.pexels.com/photos/18289391/pexels-photo-18289391.jpeg?auto=compress&cs=tinysrgb&w=1400",
    price: { label: "Free to start", detail: "Premium $19/mo · Luxury $49/mo" },
    cta: { label: "Start planning free", to: "/signup?role=couple" },
    features: [
      { icon: ListChecks, t: "Milestone timeline", d: "Every task from engagement to \"I do\", counted down to your date." },
      { icon: Wallet, t: "Budget & vendor tracker", d: "Deposits, balances and due dates you'll never miss." },
      { icon: Share2, t: "Plan with your planner", d: "Share the plan so your planner, partner and family stay in sync." },
      { icon: Users, t: "Guests & RSVPs", d: "Digital invites, meal choices and automatic reminders." },
      { icon: Globe, t: "Luxury wedding website", d: "Pick a template, add your story, share one link." },
      { icon: ImageIcon, t: "Memory vault & games", d: "Guest photos by QR code, plus games on everyone's phone." },
    ],
    steps: ["Set your wedding date", "Get your milestone plan", "Invite your planner & partner", "Tick off every milestone"],
  },
  planners: {
    key: "planners",
    tab: "Planners",
    path: "/for-planners",
    eyebrow: "For wedding planners",
    title: "You plan the magic.",
    accent: "We keep it organized.",
    blurb: "LockedInForever doesn't replace planners. It gives you and every client one organized, branded home for milestones, timelines, budgets and agreements.",
    image: U("photo-1780593116478-c46838f86523"),
    price: { label: "Planner Pro $99/mo", detail: "Unlimited clients · white-label" },
    cta: { label: "Start as a planner", to: "/signup?role=planner" },
    features: [
      { icon: Palette, t: "White-label client sites", d: "Your logo and colours. Couples see your brand, not ours." },
      { icon: LayoutGrid, t: "Multi-client dashboard", d: "Every couple, timeline and budget in one view." },
      { icon: FileSignature, t: "Agreements & e-signatures", d: "Send contracts, collect signatures and deposits." },
      { icon: CalendarCheck, t: "Shared milestone tracking", d: "You and your couples see the same checklist, so nothing slips." },
      { icon: Store, t: "Marketplace profile", d: "Get discovered by couples searching in your city." },
      { icon: Users, t: "Community & referrals", d: "Connect with venues and vendors, swap referrals." },
    ],
    steps: ["Set up your branded studio", "Invite your couples", "Plan together in real time", "Get reviews and referrals"],
  },
  venues: {
    key: "venues",
    tab: "Venues",
    path: "/for-venues",
    eyebrow: "For venues",
    title: "Every wedding you host,",
    accent: "your best advert.",
    blurb: "Branded guest experiences, live broadcasts from your ballroom and a showcase that turns each celebration into your next booking.",
    image: U("photo-1780542900375-0cf459e38fbb"),
    price: { label: "Venue Partner $99/mo", detail: "Per location · white-label guest app" },
    cta: { label: "Partner your venue", to: "/signup?role=vendor" },
    features: [
      { icon: Building2, t: "Venue showcase", d: "Photos, capacity, packages and reviews in the directory." },
      { icon: QrCode, t: "Guest QR experience", d: "Table QR codes for photo uploads, games and RSVPs." },
      { icon: Radio, t: "Live from your venue", d: "Stream ceremonies with your venue branding on screen." },
      { icon: Sparkles, t: "Reception screen", d: "Live leaderboards and guest moments on the big screen." },
      { icon: Wallet, t: "Packages & deposits", d: "Agreements, e-signatures and payments in one flow." },
      { icon: Heart, t: "Real-wedding marketing", d: "Every couple's site credits and links back to you." },
    ],
    steps: ["List your venue", "Brand your guest experience", "Host and broadcast", "Turn guests into bookings"],
  },
};

export const AUDIENCE_LIST = [AUDIENCES.couples, AUDIENCES.planners, AUDIENCES.venues];
